<template>
  <div class="f-col site-settings">
    <div class="f-row settings-header">
      <span>Configurações</span>
      <button @click="closeModal()">
        <Icon icon="times" />
      </button>
    </div>

    <div class="f-col">
      <span class="section-title">Configuração de sistema</span>

      <template v-if="actualSystem.id">
        <div class="f-col settings-info">
          <div class="f-row">
            <span>Sistema:</span>
            <span>{{ actualSystem.id }} </span>
          </div>
          <div class="f-row">
            <span>Contexto:</span>
            <span>
              {{ actualSystem.context }}
            </span>
          </div>
        </div>

        <div class="f-col settings-info">
          <div class="f-row">
            <Icon
              icon="check-circle"
              style="color: rgb(68, 170, 68); margin-right: 3px"
            />
            <span>Tudo certo! Sistema configurado</span>
          </div>
        </div>
      </template>

      <div class="f-row" v-else-if="!actualSystem.id">
        <SelectInput
          class="system-select"
          :name="
            systemSelected
              ? getSelectedSystem().email
              : 'Selecione um Ágil para vicular'
          "
          :multi="false"
          :options="systemToSelectList"
          :value="[systemSelected]"
          @change="(id) => selectSystem(id)"
        />
        <button class="bind-btn" type="button" @click.prevent="submitSystem()">
          Vicular
        </button>
      </div>
    </div>

    <div class="f-col">
      <span class="section-title">Configuração de domínio</span>

      <div class="f-col settings-info">
        <div class="f-row">
          <span>Domínio atual:</span>
          <span>{{ site.domain }}</span>
        </div>
      </div>

      <div class="f-row" v-if="domainStatus === 'unset'">
        <div class="f-row ctr form-field">
          <input
            class="f-row ctr"
            type="text"
            placeholder="Domínio"
            v-model="domainField"
          />
        </div>
        <button class="bind-btn" type="button" @click.prevent="submitDomain()">
          Vincular
        </button>
      </div>

      <div class="f-col settings-info" v-else-if="domainStatus === 'pending'">
        <div class="f-row">
          <span>Altere os NameServers do seu domínio para os seguintes</span>
        </div>
        <div class="f-row">
          <span>NS 1:</span>
          <span>{{ zone.nameServers[0] }}</span>
        </div>
        <div class="f-row">
          <span>NS 2:</span>
          <span>{{ zone.nameServers[1] }}</span>
        </div>
        <div class="f-row" v-if="zone.originalRegistrar">
          <span>Registrar do domínio: </span>
          <span>{{ zone.originalRegistrar }}</span>
        </div>
      </div>

      <div class="f-col settings-info" v-else-if="domainStatus === 'active'">
        <div class="f-row">
          <Icon
            icon="check-circle"
            style="color: rgb(68, 170, 68); margin-right: 3px"
          />
          <span>Tudo certo! Domínio configurado</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { objectJSON } from "../../config/helpers";
import axios from "axios";

export default {
  name: "SiteSettings",
  props: {
    site: Object,
  },
  data() {
    return {
      domainStatus: "",
      domainField: "",
      zone: {},
      systemList: [],
      systemToSelectList: [],
      systemSelected: null,
    };
  },
  computed: {
    actualSystem() {
      const company = objectJSON(this.site.scope).company;
      return { id: company.id, context: company.context };
    },
  },
  methods: {
    closeModal() {
      this.$store.commit("TOGGLE_DISPLAY_MODAL", {
        display: false,
        target: "",
      });
    },
    selectSystem(id) {
      this.systemSelected = id;
    },
    getSelectedSystem() {
      const [system] = this.systemList.filter(
        (sys) => sys.contextId == this.systemSelected
      );
      return system;
    },
    async fetchZone() {
      try {
        const token = this.$store.state.auth.token;
        const { data } = await axios({
          url: `${process.env.VUE_APP_SITE_API_URL}/api/websites/zones?webId=${this.site.id}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.domainStatus = data.zone.status;
        this.zone = data.zone;
      } catch (err) {
        console.warn(err?.response?.data?.message);
        this.domainStatus = "unset";
      }
    },
    async fetchSystem() {
      try {
        const token = this.$store.state.auth.token;
        const getSysResponse = await axios({
          url: `${process.env.VUE_APP_SITE_API_URL}/api/setup/crm?context=agil`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const { crms } = getSysResponse.data;
        this.systemList = crms;
        this.systemToSelectList = this.systemList
          .map((sys) => ({
            id: sys.contextId,
            name: `(${sys.contextId}) ${sys.email}`,
          }))
          .sort((a, b) => (a.id > b.id ? 1 : -1));
      } catch (err) {
        console.warn(err?.response?.data?.message);
      }
    },
    async submitDomain() {
      try {
        if (this.domainField?.length < 1) return;

        const token = this.$store.state.auth.token;
        const { data } = await axios({
          url: `${process.env.VUE_APP_SITE_API_URL}/api/websites/zones`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: {
            zone: {
              websiteId: this.site.id,
              domain: this.domainField,
              importDns: true,
            },
          },
        });
        this.domainStatus = data.zone.status;
        this.zone = data.zone;
        await this.$store.dispatch("EDITOR_CONTEXT_REQUEST");
      } catch (err) {
        console.warn(err?.response?.data?.message);
        this.$store.dispatch("ALERT", err?.response?.data?.message);
      }
    },
    async submitSystem() {
      try {
        const system = this.getSelectedSystem();
        const token = this.$store.state.auth.token;

        await axios({
          url: `${process.env.VUE_APP_SITE_API_URL}/api/setup/crm`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: {
            context: system.context,
            contextId: system.contextId,
            domain: this.site.domain,
          },
        });
        await this.$store.dispatch("EDITOR_CONTEXT_REQUEST");
        this.closeModal();
      } catch (err) {
        console.warn(err?.response?.data?.message);
        this.$store.dispatch("ALERT", err?.response?.data?.message);
      }
    },
  },
  async created() {
    try {
      await this.fetchZone();
      await this.fetchSystem();
    } catch (err) {
      console.warn(err);
    }
  },
};
</script>

<style scoped>
.site-settings {
  font-size: 14px;
}

.settings-header {
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: #333;
  margin: 2px 0 12px;
}

.section-title {
  margin: 12px 10px 4px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}

.settings-header > button > svg {
  font-size: 18px;
}

.settings-info {
  margin: 2px 10px;
}

.settings-info > div {
  margin: 2px 0;
}

.settings-info > div > span:first-of-type {
  margin-right: 4px;
  font-weight: 600;
}

.system-select {
  min-width: 320px;
  margin: 6px;
  border-radius: 0.25rem;
  background-color: #f2f2f6;
}

.form-field {
  width: 100%;
  margin: 6px;
}

.form-field > input {
  width: 100%;
  height: 46px;
  padding: 0 16px;
  font-size: 14px;
  border-radius: 0.25rem;
  background-color: #f2f2f6;
}

.bind-btn {
  height: 46px;
  padding: 0 15px;
  margin: 0 2px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 0.25rem;
  /* box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2); */
  color: #ffffff;
  background: #159ad1;
}
</style>